var map = {
	"./logo-alphabet.svg": 701,
	"./logo-amazon-2.svg": 702,
	"./logo-amazon.svg": 816,
	"./logo-azercell.svg": 817,
	"./logo-bank-of-america.svg": 818,
	"./logo-barclays.svg": 819,
	"./logo-bbc.svg": 820,
	"./logo-bloomberg.svg": 703,
	"./logo-bnp-paribas.svg": 821,
	"./logo-booking.svg": 822,
	"./logo-citibank.svg": 823,
	"./logo-cnbc.svg": 704,
	"./logo-cnbc2.svg": 824,
	"./logo-coca-cola-auto.svg": 700,
	"./logo-coca-cola-white.svg": 1648,
	"./logo-coca-cola.svg": 825,
	"./logo-deloitte.svg": 826,
	"./logo-experian.svg": 827,
	"./logo-facebook.svg": 828,
	"./logo-forbes.svg": 705,
	"./logo-g.svg": 1649,
	"./logo-goldman-sachs-new.svg": 829,
	"./logo-goldman-sachs.svg": 1461,
	"./logo-google-new.svg": 830,
	"./logo-google.svg": 831,
	"./logo-h.svg": 832,
	"./logo-henkel.svg": 833,
	"./logo-hsbc-new.svg": 834,
	"./logo-hsbc.svg": 1459,
	"./logo-ikea-new.svg": 835,
	"./logo-ikea.svg": 1650,
	"./logo-infineon.svg": 836,
	"./logo-instagram-icon.svg": 698,
	"./logo-instagram.svg": 837,
	"./logo-jp-morgan.svg": 838,
	"./logo-jti.svg": 839,
	"./logo-linkedin.svg": 840,
	"./logo-meta-new.svg": 697,
	"./logo-meta.svg": 1462,
	"./logo-morgan-stanley-new.svg": 841,
	"./logo-morgan-stanley.svg": 1460,
	"./logo-netflix.svg": 1457,
	"./logo-oracle.svg": 706,
	"./logo-paypal.svg": 842,
	"./logo-pwc-new.svg": 699,
	"./logo-pwc.svg": 1651,
	"./logo-spotify.svg": 1458,
	"./logo-tesla.svg": 843,
	"./logo-usa-today.svg": 707,
	"./logo-visa.svg": 844,
	"./logo-walmart.svg": 708,
	"./logo-wsj.svg": 709,
	"./logo-youtube.svg": 845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1345;